import * as R from 'ramda'

// > mapOverKeys(key => key + '!!!', { foo: 42, bar: null })
// { 'foo!!!': 42, 'bar!!!': null }
export const mapOverKeys = R.uncurryN(2, fn => R.pipe(
  R.toPairs,
  R.map(([k, v]) => [fn(k), v]),
  R.fromPairs,
))

// > mapOverValues(value => value * 2, { foo: 21, bar: -1 })
// { foo: 42, bar: -2 }
export const mapOverValues = R.uncurryN(2, fn => R.pipe(
  R.toPairs,
  R.map(([k, v]) => [k, fn(v)]),
  R.fromPairs,
))

// > collectToLookup('id', [{ id: 1 }, { id: 2 }, { id: 3, foo: 42 }])
// { '1': { id: 1 }, '2': { id: 2 }, '3': { id: 3, foo: 42 }}
export const collectToLookup = R.uncurryN(2, prop => R.pipe(
  R.map(obj => [obj[prop], obj]), // entries/pairs
  R.fromPairs,
))

// > toReverseIndexLookup('code', [{ code: 'click' }, { code: 'hover' }, { code: 'blur' }])
// { 'click': 0, 'hover': 1, 'blur': 2}
export const toReverseIndexLookup = R.uncurryN(2, prop => R.pipe(
  R.addIndex(R.map)((obj, i) => [obj[prop], i]), // entries/pairs
  R.fromPairs,
))

// capTitle(' foo  bar   BAZ    ') === 'Foo Bar Baz'
// capTitle('') === ''
export const capTitle = s =>
  s.split(/\s/).filter(Boolean).map(word =>
    word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
  ).join(' ')

export const wait = ms =>
  new Promise(resolve => setTimeout(resolve, ms))

// const valueOrDefault = ifNil(() => 'defaultValue')
// valueOrDefault(null) === 'defaultValue'
// valueOrDefault(undefined) === 'defaultValue'
// valueOrDefault(42) === 42
export const ifNil = R.ifElse(R.isNil, R.__, R.identity)
